import {isNative} from "@/shared/helpers/webapp";
import {useSunmiStore} from "@/console-sun/stores/sunmi.store";
import EscPos from "@/shared/helpers/EscPos";

export const PosPrinter = {
	printPOSCloseOut: (businessName, dateStart, dateEnd, amount, txNumber, refundsNumber, cancelsNumber, totalFees) => {
		if(!isNative()) { return; }
		let today = new Date();
		let month = today.getMonth()+1;
		let day = (today.getDate() < 10 ? '0' : '') + today.getDate() + '/' + (month < 10 ? '0' : '') + month;
		let hours = (today.getHours() < 10 ? '0' : '') + today.getHours()+':'+(today.getMinutes() < 10 ? '0' : '') + today.getMinutes()
		let dateString = day+' '+hours

		let monthStart = dateStart.getMonth()+1;
		let dayStart = (dateStart.getDate() < 10 ? '0' : '') + dateStart.getDate() + '/' + (monthStart < 10 ? '0' : '') + monthStart;
		let hoursStart = (dateStart.getHours() < 10 ? '0' : '') + dateStart.getHours()+':'+(dateStart.getMinutes() < 10 ? '0' : '') + dateStart.getMinutes()
		let dateStartString = dayStart+' '+hoursStart

		let monthEnd = dateEnd.getMonth()+1;
		let dayEnd = (dateEnd.getDate() < 10 ? '0' : '') + dateEnd.getDate() + '/' + (monthEnd < 10 ? '0' : '') + monthEnd;
		let hoursEnd = (dateEnd.getHours() < 10 ? '0' : '') + dateEnd.getHours()+':'+(dateEnd.getMinutes() < 10 ? '0' : '') + dateEnd.getMinutes()
		let dateEndString = dayEnd+' '+hoursEnd

		const esc = EscPos.init();
		let printOutput = "";
		printOutput += esc.spaceBetween("Qromo POS", dateString);
		printOutput += esc.justifyCenter("Da "+dateStartString+" a "+dateEndString)+"\n";
		printOutput += esc.justifyCenter(esc.bold(businessName))+"\n";
		printOutput += esc.justifyCenter(esc.doubleSize((amount/100).toFixed(2)+" EUR"))+"\n";
		printOutput += esc.justifyCenter("Fees "+((totalFees/1.22)/100).toFixed(2)+" + IVA = "+((totalFees)/100).toFixed(2)+" EUR");
		printOutput += esc.justifyCenter(esc.bold("Netto "+((amount-totalFees)/100).toFixed(2)+" EUR"))+"\n";
		printOutput += esc.spaceBetween("Transazioni", "", false, true);
		printOutput += esc.spaceBetween("Riuscite", txNumber.toString());
		printOutput += esc.spaceBetween("Annullate", cancelsNumber.toString());
		printOutput += esc.spaceBetween("Rimborsi", refundsNumber.toString());
		printOutput += "\n\n\n\n";

		useSunmiStore().enqueuePrint(printOutput);
	},
}
